// components/LoadingAnimation.js
import React from 'react';
import { Box } from '@mui/material';
import KastLogo from '../K.png'; // Adjust the path to your logo

const LoadingAnimation = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: '40%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 9999,
        textAlign: 'center'
      }}
    >
      <Box
        component="img"
        src={KastLogo}
        alt="Loading..."
        sx={{
          width: 60,
          height: 60,
          animation: 'spin 2s linear infinite',
          '@keyframes spin': {
            '0%': {
              transform: 'rotate(0deg)',
            },
            '100%': {
              transform: 'rotate(360deg)',
            },
          },
        }}
      />
    </Box>
  );
};

export default LoadingAnimation;